var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-block"},[_c('p',[_vm._v(_vm._s(_vm.$t("account.sorryToSeeYouGo")))]),_c('eg-b-form-checkbox',{staticClass:"w-100 mb-1",model:{value:(_vm.isConfirm),callback:function ($$v) {_vm.isConfirm=$$v},expression:"isConfirm"}},[_vm._v(" "+_vm._s(_vm.$t("account.cancelFinalConfirm"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }